"use client"

import { useSyncExternalStore } from "react"
import { useAuthStore } from "@/stores/auth-store"
import { apiGet, apiMutate } from "@/lib/workspace-api"
import { createAiConsentController } from "./core/ai-consent"
import type { AiConsent } from "./core/ai-consent"
export { ConsentCancelledError, consentIsCurrent } from "./core/ai-consent"

const path = "/v1/users/me/ai-consent"
function verifiedUserId() {
  const auth = useAuthStore.getState()
  return auth.status === "authenticated" && !auth.isVerifyingSession ? auth.user?.user_id ?? null : null
}
export const aiConsent = createAiConsentController({
  userId: verifiedUserId,
  get: async () => (await apiGet<AiConsent>(path)).data,
  grant: async (version) => (await apiMutate<AiConsent>(path, { method: "POST", idempotencyKey: crypto.randomUUID(), body: JSON.stringify({ version, client: "web" }) })).data,
  revoke: async () => (await apiMutate<AiConsent>(path, { method: "DELETE", idempotencyKey: crypto.randomUUID(), body: JSON.stringify({}) })).data,
})
useAuthStore.subscribe((next, previous) => {
  if (next.user?.user_id !== previous.user?.user_id || next.status === "guest") aiConsent.reset()
})
export const requireAiConsent = () => aiConsent.requireConsent()
export const showAiConsentDisclosure = () => { void aiConsent.requireConsent(true) }
export function useAiConsentState() {
  return useSyncExternalStore(aiConsent.subscribe, aiConsent.getSnapshot, aiConsent.getSnapshot)
}
